{
  "cycle.entite.adr_reviews": "ADR review rounds",
  "cycle.entite.architecture_lignes_de_base": "Architecture baselines",
  "journalAudit.action.adr.cancelled": "ADR cancelled",
  "journalAudit.action.adr.superseded": "ADR superseded",
  "journalAudit.action.architecture.ligne_de_base.figee": "Architecture baseline frozen",
  "journalAudit.action.technology_change.rework_verified": "Technology change rework verified"
}
